import React, { useId } from 'react';

const MergeIcon = (props) => {
  const gradientId = useId();

  return (
    <svg
      width={props?.width || 24}
      height={props?.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Circular arrow path */}
      <path
        d="M12 5V2L7 6.5L12 11V8C14.76 8 17 10.24 17 13C17 15.76 14.76 18 12 18C9.24 18 7 15.76 7 13H5C5 17.42 8.58 21 13 21C17.42 21 21 17.42 21 13C21 8.58 17.42 5 13 5H12Z"
        stroke={`url(#${gradientId})`}
        strokeWidth="2"
        fill="none"
      />

      {/* Gradient */}
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6C54A3" />
          <stop offset="1" stopColor="#00B1D2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MergeIcon;
